import Vue from 'vue' //引入vue
import VueI18n from 'vue-i18n' //引入vue-i18n

Vue.use(VueI18n)
let DEFAULT_LANG = navigator.language; //默认语言 navigator.language "zh-CN"
if (DEFAULT_LANG.indexOf('zh') != -1) {
    DEFAULT_LANG = 'zh-CN';
} else if (DEFAULT_LANG.indexOf('ja') != -1) {
    DEFAULT_LANG = 'ja';
} else if (DEFAULT_LANG.indexOf('th') != -1) {
    DEFAULT_LANG = 'th';
} else {
    DEFAULT_LANG = 'en';
}
const LOCALE_KEY = 'localeLanguage' //要缓存在浏览器使用的key
const locales = { //配置语言文件
    'zh-CN': require('./zh_cn.json'),
    ja: require('./ja.json'),
    en: require('./en.json'),
    th: require('./th.json') // 泰语
}

const i18n = new VueI18n({ //声明一个多语言实例
    locale: DEFAULT_LANG,
    messages: locales,
})

export const setup = lang => { //定义一个修改语言的方法
    if (lang === undefined) {
        lang = window.localStorage.getItem(LOCALE_KEY)
        if (locales[lang] === undefined) {
            lang = DEFAULT_LANG
        }
    }
    window.localStorage.setItem(LOCALE_KEY, lang)

    Object.keys(locales).forEach(lang => {
        document.body.classList.remove(`lang-${lang}`)
    })
    document.body.classList.add(`lang-${lang}`)
    document.body.setAttribute('lang', lang)

    Vue.config.lang = lang
    i18n.locale = lang
}

setup()
export default i18n


// WEBPACK FOOTER //
// ./src/locales/index.js